export default __webpack_public_path__ + "static/media/image_primary.4420cdc5.png";